import React from 'react';
import cn from 'classnames';
import css from './le-warning.scss';
const LE_TEXT = 'Limited edition products may not be available when checking out.';
export const LEWarning = ({
  show,
  isCheckout
}) => show ? /*#__PURE__*/React.createElement("span", {
  className: cn(css.wrapper, {
    [css.isCheckout]: isCheckout
  })
}, /*#__PURE__*/React.createElement("span", {
  className: css.infoButton
}), /*#__PURE__*/React.createElement("span", {
  className: css.text
}, LE_TEXT)) : null;